// import cn from "classnames";
// import { useTranslation } from "react-i18next";

// import { Button } from "shared/ui/components/Button";

import { Typography } from "shared/ui/components/Typography";

// import { BookedButton } from "../BookedButton";

import { Post } from "types/post.type";

import styles from "./ObjectBanner.module.scss";

const ObjectBanner = ({
  // post,
  // onDatePickerToggleClick,
}: {
  post?: Post;
}) => {
  // const { t } = useTranslation();

  return (
    <div className={styles.inner}>
      <Typography className={styles.title} variant="h2" weight="semiBold">
        Kostenlose und unverbindliche Analyse
      </Typography>
      <Typography className={styles.description} variant="bodyM" weight="light">
        Erklärung der wichtigsten Objektkennzahlen: Rendite, Kosten, Steuereffekte und Finanzierung.
      </Typography>
      <div className={styles.footer}>
        {/* {!!post && (
          <BookedButton post={post}
            source="Summary Item Button"
            buttonText="Termin vereinbaren"
          />
        )}
        {!post && (
          <Button
            className={cn(styles.bookingButtonDesktop)}
            variant="black"
            onClick={() => {
              onDatePickerToggleClick("desktop");
            }}
          >
            {t("investment_page.online_consultation_30_min")}
          </Button>
        )}
        {!post && (
          <Button
            className={cn(styles.bookingButtonMobile)}
            variant="black"
            onClick={() => {
              onDatePickerToggleClick("mobile");
            }}
          >
            {t("investment_page.online_consultation_30_min")}
          </Button>
        )} */}
      </div>
    </div>
  );
};

export default ObjectBanner;
